import { IDisplayPrice, IOCAPIProductPromotion } from '../types';

export const poll = (fn: () => boolean, timeout: number, interval: number) => {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    } else if (Number(new Date()) < endTime) {
      // If the condition isn't met but the timeout hasn't elapsed, go again
      setTimeout(checkCondition, interval, resolve, reject);
    } else {
      // Didn't match and too much time, reject!
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise<boolean>(checkCondition);
};

export const pollWindowVariable = async (property: string, timeout: number = 2000) => {
  try {
    const w = window as any;
    await poll(
      () => {
        return w[property];
      },
      timeout,
      150
    );

    return w[property];
  } catch (error) {
    return null;
  }
};

export const pollWindowVariables = (properties: string[]) => {
  const promises = properties.map(property => {
    return new Promise(resolve => resolve(pollWindowVariable(property)));
  });

  return promises;
};

export const formatMasterProductPrice = (price: number, productDisplayPrice: string) => {
  let displayPrice = JSON.parse(productDisplayPrice),
    promoPrice = price,
    regularPrice = price;

  if (price === null) {
    return null;
  }

  if (typeof displayPrice.promo_price !== 'object') {
    promoPrice = displayPrice.promo_price;
  }

  /**
   * when the regular price is returned as a object,
   * and only the promo price is setup use, promo price as regular
   */
  if (typeof displayPrice.regular === 'object') {
    regularPrice = promoPrice;
  } else {
    regularPrice = displayPrice.regular;
  }

  return {
    ...displayPrice,
    regular: regularPrice,
    promo_price: promoPrice
  };
};

export const formatVariantProductPrice = (product: any): IDisplayPrice | null => {
  const promos: IOCAPIProductPromotion[] = product.product_promotions.filter((promotion: any) =>
    promotion.hasOwnProperty('promotional_price')
  );

  if (!promos.length) {
    return {
      regular: product.price,
      promo_price: null,
      has_same_variant_prices: true,
      percent_off: 0
    };
  }

  const promoPrice = promos.reduce((min, cur) => {
    return cur.promotional_price < min ? cur.promotional_price : min;
  }, promos[0].promotional_price);

  /**
   * Custom product data from OCAPI response.
   * You can add other properties from the OCAPI response when needed
   */
  const formatPromoPrice = {
    regular: product.price,
    promo_price: promoPrice,
    has_same_variant_prices: true,
    percent_off: getPercentOff(product.price, promoPrice)
  };

  return formatPromoPrice;
};

const getPercentOff = (regular: number, promo: number): number => {
  const difference = regular - promo;
  return Math.round(100 - difference * 100 / regular) / 100;
};

export const getAmount = (value: string | number) =>
  typeof value !== 'number' ? parseFloat(value) : value;

export const sendEvent = (action: string, additionalParams: any = {}) => {
  // @ts-ignore
  if (typeof window.tc_events_100 !== 'undefined') {
    // @ts-ignore
    window.tc_events_100(this, 'clickevent', { ACTION: action, ...additionalParams });
  }
};

export const sendWaData = async ({
                                   siteSection,
                                   pageName
                                 }: {
  siteSection: string;
  pageName: string;
}) => {
  try {
    const wa_data = await pollWindowVariable('wa_data');
    if (wa_data) {
      setTimeout(() => {
        wa_data.siteSection = siteSection;
        wa_data.pageName = pageName;
      }, 0);
    }
  } catch (error) {
    console.error(error);
  }
};
